import { useTranslation } from 'react-i18next'
import { mdiCheckDecagramOutline  } from '@mdi/js'
import { Badge } from '../ui/badge'
import { AppIcon } from '../ui/icon'
import { SECTION_ICONS } from '../../lib/section-icons'

/**
 * The two signature markers of a document (spec 2026-10-06-02): `signed` on the
 * sealed PDF a completed request filed, `was_signed` on the source it came
 * from. Both ride on `documents.flags`.
 */
export function SignedFlagBadges({ flags, testidPrefix }: { flags?: string[] | null; testidPrefix: string }) {
  const { t } = useTranslation('documents')
  return (
    <>
      {flags?.includes('signed') && (
        <Badge variant="success" className="shrink-0 gap-1" data-testid={`${testidPrefix}-signed`}>
          <AppIcon path={mdiCheckDecagramOutline} size="xs" />
          {t('signed_flags.signed')}
        </Badge>
      )}
      {flags?.includes('was_signed') && (
        <Badge variant="info" className="shrink-0 gap-1" data-testid={`${testidPrefix}-was-signed`}>
          <AppIcon path={SECTION_ICONS.signatures} size="xs" />
          {t('signed_flags.was_signed')}
        </Badge>
      )}
    </>
  )
}
